<template>
    <span>
        <TDatetime 
            :hidden="op === 'is_null' || op == 'is_not_null'"
            :modelValue="value" 
            @input.stop 
            @update:modelValue="$emit('input', $event)"
        ></TDatetime>
    </span>
</template>
<script>
import { 
    TDatetime
} from '@roonlabs/vue-tailwind'
export default {
    name: 'TimestampInput',
    components: { TDatetime },
    props: {
        value: String ,
        op: String
    },
}
</script>
